export const ANALYTICS_QUESTIONNAIRE_STORAGE_KEY = 'onboarding.questionnaireValues'
export const TEAM_NAME_STORAGE_KEY = 'onboarding.teamName'
export const RETURN_URL_STORAGE_KEY = 'onboarding.returnUrl'
